import _slicedToArray from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import * as asn1js from "asn1js";
import { getParametersValue, isEqualBuffer, clearProps } from "pvutils";
import AttributeTypeAndValue from "./AttributeTypeAndValue.js"; //**************************************************************************************

/**
 * Class from RFC5280
 */

var RelativeDistinguishedNames = /*#__PURE__*/function () {
  //**********************************************************************************

  /**
   * Constructor for RelativeDistinguishedNames class
   * @param {Object} [parameters={}]
   * @param {Object} [parameters.schema] asn1js parsed value to initialize the class from
   * @property {Array.<AttributeTypeAndValue>} [typesAndValues] Array of "type and value" objects
   * @property {ArrayBuffer} [valueBeforeDecode] Value of the RDN before decoding from schema
   */
  function RelativeDistinguishedNames() {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RelativeDistinguishedNames);

    //region Internal properties of the object

    /**
     * @type {Array.<AttributeTypeAndValue>}
     * @desc Array of "type and value" objects
     */
    this.typesAndValues = getParametersValue(parameters, "typesAndValues", RelativeDistinguishedNames.defaultValues("typesAndValues"));
    /**
     * @type {ArrayBuffer}
     * @desc Value of the RDN before decoding from schema
     */

    this.valueBeforeDecode = getParametersValue(parameters, "valueBeforeDecode", RelativeDistinguishedNames.defaultValues("valueBeforeDecode")); //endregion
    //region If input argument array contains "schema" for this object

    if ("schema" in parameters) this.fromSchema(parameters.schema); //endregion
  } //**********************************************************************************

  /**
   * Return default values for all class members
   * @param {string} memberName String name for a class member
   */


  _createClass(RelativeDistinguishedNames, [{
    key: "fromSchema",
    //**********************************************************************************

    /**
     * Convert parsed asn1js object into current class
     * @param {!Object} schema
     */
    value: function fromSchema(schema) {
      //region Clear input data first
      clearProps(schema, ["RDN", "typesAndValues"]); //endregion
      //region Check the schema is valid

      var asn1 = asn1js.compareSchema(schema, schema, RelativeDistinguishedNames.schema({
        names: {
          blockName: "RDN",
          repeatedSet: "typesAndValues"
        }
      }));
      if (asn1.verified === false) throw new Error("Object's schema was not verified against input data for RelativeDistinguishedNames"); //endregion
      //region Get internal properties from parsed schema

      if ("typesAndValues" in asn1.result) // Could be a case when there is no "types and values"
        this.typesAndValues = Array.from(asn1.result.typesAndValues, function (element) {
          return new AttributeTypeAndValue({
            schema: element
          });
        }); // noinspection JSUnresolvedVariable

      this.valueBeforeDecode = asn1.result.RDN.valueBeforeDecode; //endregion
    } //**********************************************************************************

    /**
     * Convert current object to asn1js object and set correct values
     * @returns {Object} asn1js object
     */

  }, {
    key: "toSchema",
    value: function toSchema() {
      //region Decode stored TBS value
      if (this.valueBeforeDecode.byteLength === 0) // No stored encoded array, create "from scratch"
        {
          return new asn1js.Sequence({
            value: [new asn1js.Set({
              value: Array.from(this.typesAndValues, function (element) {
                return element.toSchema();
              })
            })]
          });
        }

      var asn1 = asn1js.fromBER(this.valueBeforeDecode); //endregion
      //region Construct and return new ASN.1 schema for this object

      return asn1.result; //endregion
    } //**********************************************************************************

    /**
     * Convertion for the class to JSON object
     * @returns {Object}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        typesAndValues: Array.from(this.typesAndValues, function (element) {
          return element.toJSON();
        })
      };
    } //**********************************************************************************

    /**
     * Compare two RDN values, or RDN with ArrayBuffer value
     * @param {(RelativeDistinguishedNames|ArrayBuffer)} compareTo The value compare to current
     * @returns {boolean}
     */

  }, {
    key: "isEqual",
    value: function isEqual(compareTo) {
      if (compareTo instanceof RelativeDistinguishedNames) {
        if (this.typesAndValues.length !== compareTo.typesAndValues.length) return false;

        var _iterator = _createForOfIteratorHelper(this.typesAndValues.entries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                index = _step$value[0],
                typeAndValue = _step$value[1];

            if (typeAndValue.isEqual(compareTo.typesAndValues[index]) === false) return false;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return true;
      }

      if (compareTo instanceof ArrayBuffer) return isEqualBuffer(this.valueBeforeDecode, compareTo);
      return false;
    } //**********************************************************************************

  }], [{
    key: "defaultValues",
    value: function defaultValues(memberName) {
      switch (memberName) {
        case "typesAndValues":
          return [];

        case "valueBeforeDecode":
          return new ArrayBuffer(0);

        default:
          throw new Error("Invalid member name for RelativeDistinguishedNames class: ".concat(memberName));
      }
    } //**********************************************************************************

    /**
     * Compare values with default values for all class members
     * @param {string} memberName String name for a class member
     * @param {*} memberValue Value to compare with default value
     */

  }, {
    key: "compareWithDefault",
    value: function compareWithDefault(memberName, memberValue) {
      switch (memberName) {
        case "typesAndValues":
          return memberValue.length === 0;

        case "valueBeforeDecode":
          return memberValue.byteLength === 0;

        default:
          throw new Error("Invalid member name for RelativeDistinguishedNames class: ".concat(memberName));
      }
    } //**********************************************************************************

    /**
     * Return value of pre-defined ASN.1 schema for current class
     *
     * ASN.1 schema:
     * ```asn1
     * RDNSequence ::= Sequence OF RelativeDistinguishedName
     *
     * RelativeDistinguishedName ::=
     * SET SIZE (1..MAX) OF AttributeTypeAndValue
     * ```
     *
     * @param {Object} parameters Input parameters for the schema
     * @returns {Object} asn1js schema object
     */

  }, {
    key: "schema",
    value: function schema() {
      var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /**
       * @type {Object}
       * @property {string} [blockName] Name for entire block
       * @property {string} [repeatedSequence] Name for "repeatedSequence" block
       * @property {string} [repeatedSet] Name for "repeatedSet" block
       * @property {string} [typeAndValue] Name for "typeAndValue" block
       */
      var names = getParametersValue(parameters, "names", {});
      return new asn1js.Sequence({
        name: names.blockName || "",
        value: [new asn1js.Repeated({
          name: names.repeatedSequence || "",
          value: new asn1js.Set({
            value: [new asn1js.Repeated({
              name: names.repeatedSet || "",
              value: AttributeTypeAndValue.schema(names.typeAndValue || {})
            })]
          })
        })]
      });
    }
  }]);

  return RelativeDistinguishedNames;
}(); //**************************************************************************************


export { RelativeDistinguishedNames as default };